import { TimeIcon } from '@fourthwall/icons';
import React, { useState } from 'react';
import { Input } from '../../inputs/Input';
import * as S from './Calendar.styled';
import { useTime } from './hooks/useTime';
export const CalendarTimeInput = ({ value, label, isValid, onValueChange, }) => {
    const [isFocused, setIsFocused] = useState(false);
    const { format } = useTime();
    const formattedValue = format(value);
    const handleValueChange = (newValue) => {
        onValueChange(format(newValue.toUpperCase()));
    };
    const renderMaskCharacters = (mask) => {
        return mask.split('').map((letter, index) => (React.createElement(S.TimeInputMaskLetter, { key: index, "$hidden": index < formattedValue.length }, index < formattedValue.length ? formattedValue[index] : letter)));
    };
    return (React.createElement(S.TimeInputContainer, null,
        React.createElement(Input, { label: label, size: "medium", value: formattedValue, error: !isValid && !isFocused, displayError: false, leftIcon: TimeIcon, onValueChange: handleValueChange, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false) }),
        isFocused && React.createElement(S.TimeInputMask, null, renderMaskCharacters('HH:MM AM'))));
};
